const disputes = {
  'disputes.continue': 'Continuar',

  'disputes.categories.FRAUD': 'Não reconheço essa compra',
  'disputes.categories.PROCESSING_ERROR': 'Há algo errado com a minha compra',
  'disputes.categories.DISAGREEMENT': 'O valor cobrado está errado',

  'disputes.whatIssue': 'O que aconteceu?',
  'disputes.comment.placeholder': 'Descreva o que houve',

  'disputes.fraudDisclaimer1':
    'Por medida de segurança, este cartão será bloqueado imediatamente.',
  'disputes.fraudDisclaimer2': 'Uma segunda via será enviada para o endereço:',

  'disputes.submit.success':
    'Contestação em análise. Os próximos contatos serão realizados por e-mail.',
  'disputes.submit.failure':
    'Ocorreu um erro ao solicitar contestação, por favor tente novamente mais tarde.',

  'disputes.total_transactions': 'Total de transações contestadas',

  'disputes.ANALYSING': 'Em análise',
  'disputes.APPROVED': 'Aprovada',
  'disputes.CANCELED': 'Cancelada',
  'disputes.DENIED': 'Negada',
  'disputes.DRAFT': 'Draft',
  'disputes.OPEN': 'Aberta',
};

export default disputes;
